import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Input } from '@/components/Input';
import { theme } from '@/theme';

import type { StyleType } from '../types';

export const Wrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};

  ${theme.media.md.up} {
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const CharacterBox = styled(Box)<{ $withSeparater?: boolean }>`
  position: relative;

  ${({ $withSeparater, theme }) =>
    $withSeparater &&
    css`
      &:after {
        content: '.';
        position: absolute;
        right: -11px;
        bottom: 0;
        font-size: ${theme.fontSizes.h4};
      }
    `}
`;

export const CharacterInput = styled(Input)<{
  $isDate?: boolean;
  $style: StyleType;
}>`
  ${({ $isDate, $style, theme }) => css`
    border: 1px solid ${theme.colors.borderGrey};
    width: ${$isDate ? '24px' : '40px'};
    height: 50px;
    padding: ${theme.spacing(1, 0)};
    font-size: ${theme.fontSizes.h4};
    font-weight: ${theme.fontWeights.semibold};
    font-family: ${$style === 'Block'
      ? theme.fontFamilies.engravingBlock
      : theme.fontFamilies.engravingCursive};
    text-align: center;
    &:focus {
      outline: none;
    }

    &::selection {
      background: transparent;
      color: inherit;
    }
    &::-moz-selection {
      background: transparent;
      color: inherit;
    }
  `}
`;

export const WithSeparatorsBox = styled(Box)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const MessageInputWrapper = styled(Box)`
  width: 100%;
`;

export const MessageInput = styled(Input)<{
  $hasError: boolean;
  $style: StyleType;
}>`
  ${({ $hasError, $style, theme }) => css`
    border: 1px solid
      ${$hasError ? theme.colors.error : theme.colors.borderGrey};
    width: 100%;
    height: 50px;
    padding: ${theme.spacing(1, 1.5)};
    font-size: ${theme.fontSizes.h4};
    font-weight: ${theme.fontWeights.semibold};
    font-family: ${$style === 'Block'
      ? theme.fontFamilies.engravingBlock
      : theme.fontFamilies.engravingCursive};
    text-align: left;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.primaryBlue};
      outline-offset: 1px;
    }

    &::selection {
      background: transparent;
      color: inherit;
    }
    &::-moz-selection {
      background: transparent;
      color: inherit;
    }

    &::placeholder {
      color: ${theme.colors.secondaryGrey};
      font-family: ${theme.fontFamilies.openSans};
      font-size: ${theme.fontSizes.p2};
      font-weight: ${theme.fontWeights.regular};
    }
  `}
`;
